import { IconButton, QualityDetails, QualityPerformance, SectionTitle } from '@sloyd/ui';
import { useState } from 'react';
import { useCounter } from 'react-use';
import { numeric } from 'shared-base';
import { Close, Content, Overlay, Top, Wrapper } from './ContentQuality.style';

export type ContentQualityProps = {
  qualities: IQuality[];
  callbacks: {
    onRate: (id: string, rating: number) => void;
  };
};

export function ContentQuality(props: ContentQualityProps) {
  const { qualities, callbacks } = props;
  const [index, { inc, dec }] = useCounter(0, qualities.length - 1, 0);
  const [showDetails, setShowDetails] = useState(false);

  const total = qualities.length;

  function renderDetails() {
    if (!showDetails) return null;
    const quality = qualities[index];

    return (
      <Overlay>
        <Close>
          <IconButton onClick={() => setShowDetails(false)} color='white' size={50} name='IconX' />
        </Close>
        <QualityDetails
          item={quality}
          index={index}
          total={total}
          onPrev={() => dec()}
          onNext={() => inc()}
          onRate={(rating: number) => {
            callbacks.onRate(quality.id, rating);
            inc();
          }}
        />
      </Overlay>
    );
  }

  return (
    <Wrapper className='ContentQuality-wrapper' data-testid='ContentQuality-wrapper'>
      <SectionTitle
        gradient={{ from: '#ff6a00', to: '#ee0979' }}
        title='Quality'
        cta={`Evaluate (${numeric(total)})`}
        ctaIcon='IconTestPipe'
        onCta={() => setShowDetails(true)}
      >
        Evaluate IOs for Sloyd's AI Services
      </SectionTitle>
      <Top>
        <QualityPerformance />
      </Top>
      <Content></Content>
      {renderDetails()}
    </Wrapper>
  );
}

export default ContentQuality;
